import {
	EVENT_ACTION_PARKING_BOOKING_DETAILS_CANCEL_CONFIRMATION,
	EVENT_CATEGORY_PARKING_BOOKING_DETAILS,
	trackCustomEvent,
} from '../../../../../../shared/analytics';

export function trackClickedCancelBookingAbort() {
	trackCustomEvent({
		category: EVENT_CATEGORY_PARKING_BOOKING_DETAILS,
		action: EVENT_ACTION_PARKING_BOOKING_DETAILS_CANCEL_CONFIRMATION,
		label: 'Cancel',
	});
}
